import { endOfDay, isValid, isWithinInterval, startOfDay } from 'date-fns';

import { DateRange } from '../model/date-range.model';
import { ViewTaskItem } from '../model/view-task-item.model';

export function filterByDateRange(
    dateRange: DateRange | null,
    items: ViewTaskItem[],
): ViewTaskItem[] {
    if (
        dateRange == null ||
        !isValid(dateRange.from) ||
        !isValid(dateRange.to)
    ) {
        return [...items];
    }

    const interval = {
        start: startOfDay(dateRange.from),
        end: endOfDay(dateRange.to),
    };

    return items.filter((e) => {
        return (
            e.dueDateTime != null && isWithinInterval(e.dueDateTime, interval)
        );
    });
}
